// extracted by mini-css-extract-plugin
export var grayCircle = "_dp-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dp-1";
export var selectedCircle = "_dp-2";
export var shippingOptionImage = "_dp-3";
export var shippingOptionWidgetPreview = "_dp-4";